// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2OMjp","title":"ClientReferral_title__2OVcw","itemText":"ClientReferral_itemText__3OZTF"};